import {
  PrimaryButton,
  SecondaryButton,
  SingleFileUploader,
} from "@graffer-inc/console-design-kit";
import * as React from "react";
import { toast } from "react-toastify";
import { BaseModal } from "../../../atoms/base-modal";

interface CertificateFileUploadModalProps {
  isActive: boolean;
  onClose: () => void;
  onUploadFile: (file: File, dateUri: string) => void;
}

export const CertificateFileUploadModal: React.FC<
  CertificateFileUploadModalProps
> = ({ isActive, onClose, onUploadFile }) => {
  const [file, setFile] = React.useState<File | undefined>();
  const [fileDataUri, setFileDataUri] = React.useState<string | undefined>();

  const handleSetFile = React.useCallback((file: File | undefined) => {
    if (!file) {
      // file選択せずにキャンセルしたパターン
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = function () {
      const dataUri = this.result as string;
      setFileDataUri(dataUri.split(",")[1]);
    };
    fileReader.readAsDataURL(file);
    setFile(file);
  }, []);

  const handleDeleteFile = React.useCallback(() => {
    setFile(undefined);
    setFileDataUri(undefined);
  }, []);

  const handleUpload = React.useCallback(() => {
    if (!file || !fileDataUri) {
      toast.error("ファイルを選択してください。");
      return;
    }
    onUploadFile(file, fileDataUri);
    onClose();
  }, [file, fileDataUri, onUploadFile]);

  return (
    <BaseModal
      isActive={isActive}
      title="X509証明書ファイルのアップロード"
      onClose={onClose}
    >
      <section className="modal-card-body">
        <SingleFileUploader
          label="X509証明書ファイル"
          description="PEM形式でエンコードされたIDプロバイダのX509証明書ファイルをアップロードしてください。"
          required
          value={file}
          setFile={handleSetFile}
          deleteFile={handleDeleteFile}
        />
      </section>
      <section className="modal-card-foot">
        <SecondaryButton
          text="閉じる"
          onClick={() => {
            onClose();
          }}
        />
        <PrimaryButton
          text="アップロード"
          onClick={handleUpload}
          disabled={!file || !fileDataUri}
        />
      </section>
    </BaseModal>
  );
};
